import loadable from '@loadable/component';

export const LoudersoundSiteWrapper = loadable(
  () => import(/* webpackChunkName: "loudersound-site" */ './LoudersoundSiteWrapper'),
);
